import React, { useEffect, useState } from "react";
import { Mail, UserPen } from "lucide-react";

import { TextInput } from "../shared/Inputs";

import { useGetAccountInfo } from "../../hooks/user_piis";

export const Settings = () => {

    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [username, setUsername] = useState<string>("");
    const [role, setRole] = useState<string>("");

    const { data } = useGetAccountInfo();

    useEffect(() => {
        if (data) {
            setFirstName(data.first_name ?? "");
            setLastName(data.last_name ?? "");
            setEmail(data.email ?? "");
            setUsername(data.username ?? "");
        };
    }, [data]);

    return (
        <div className="settings__page">
            <p className='text-4xl text-bold color--primary mb-md'>Settings</p>
            <p className='text-lg color--txt-secondary mb-2xl'>Manage personal details and preferences here.</p>
            <div className="settings__block">
                <p className="text-2xl text-semibold pb-xl">Personal info</p>
                <div className="settings__block__content">
                    <div className="settings__block__left">
                        <p className="text-sm text-medium color--txt-secondary">Name</p>
                    </div>
                    <div className="settings__block__right">
                        <div className="d-flex gap-xl">
                            <TextInput
                                placeholder="First Name"
                                value={firstName}
                                onChange={e => setFirstName(e.target.value)}
                            />
                            <TextInput
                                placeholder="Last Name"
                                value={lastName}
                                onChange={e => setLastName(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="settings__block__content">
                    <div className="settings__block__left">
                        <p className="text-sm text-medium color--txt-secondary">Email address</p>
                    </div>
                    <div className="settings__block__right">
                        <TextInput
                            icon={{ icon: <Mail />, position: 'prefix' }}
                            placeholder="Email address"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            disabled
                        />
                        <p className="text-sm text-medium color--txt-disabled mt-xs">Managed by your organization</p>
                    </div>
                </div>
                <div className="settings__block__content">
                    <div className="settings__block__left">
                        <p className="text-sm text-medium color--txt-secondary">User name</p>
                    </div>
                    <div className="settings__block__right">
                        <TextInput
                            icon={{ icon: <UserPen />, position: 'prefix' }}
                            placeholder="Username"
                            value={username}
                            disabled
                        />
                    </div>
                </div>
                <div className="settings__block__content">
                    <div className="settings__block__left">
                        <p className="text-sm text-medium color--txt-secondary">Role</p>
                    </div>
                    <div className="settings__block__right">
                        <TextInput
                            placeholder="Marketing Manager"
                            value={role}
                            onChange={e => setRole(e.target.value)}
                            disabled
                        />
                        <p className="text-sm text-medium color--txt-disabled mt-xs">Managed by your organization</p>
                    </div>
                </div>
            </div>
            <div className="settings__block pt-xl">
                <p className="text-2xl text-semibold pb-xl">Security</p>
                <div className="settings__block__content">
                    <div className="settings__block__left">
                        <p className="text-sm text-medium color--txt-secondary">Password</p>
                    </div>
                    <div className="settings__block__right">
                        <button className="btn btn--sm btn--radius-sm btn--secondary">Change Password</button>
                    </div>
                </div>
            </div>
            <div className="settings__actions">
                <button className="btn btn--sm btn--radius-sm btn--secondary">Cancel</button>
                <button className="btn btn--sm btn--radius-sm btn--primary">Update</button>
            </div>
        </div>
    );
};